import Modal from "@mui/material/Modal";
import {kButtonStyles, kModalStyles} from "../../../constants/styles";
import SystemDialogHeaderLayout from "../../layouts/SystemDialogHeaderLayout";
import SystemDialogClosingCrossIcon from "../../icons/SystemDialogClosingCrossIcon";
import SystemDialogMainImage from "../../images/SystemDialogMainImage";
import {kSystemImages} from "../../../constants/images";
import SystemModalTexts from "../../texts/SystemModalTexts";
import {kSystemTexts} from "../../../constants/texts";
import {SystemPrimaryCustomButton, SystemSecondaryCustomButton} from "../../buttons/SystemCustomButton";

export default function GamesLeaveDialog({ open,
                                           handleClose,
                                           leave }) {
    // Used in MetaFlashScreen to ask confirmation
    // about leaving current flash

    // BUILD
    return(
        <Modal open={open}
               onClose={handleClose}>
            <div className={kModalStyles.dialogStyle}>
                <SystemDialogHeaderLayout>
                    <SystemDialogClosingCrossIcon onIconPress={() => handleClose()}/>
                    <SystemDialogMainImage imageUrl={kSystemImages.happyFox}
                                           alt="Quitter" />
                </SystemDialogHeaderLayout>
                <SystemModalTexts title={"Quitter le jeu ?"}
                                  subtitle={"Ta progression actuelle sera perdue"} />
                <div className="w-full flex space-x-[16px]">
                    <SystemSecondaryCustomButton
                        label={kSystemTexts.cancel}
                        isDisabled={false}
                        isLoading={false}
                        isFullWidth={true}
                        sizeStyle={kButtonStyles.mediumButtonStyle}
                        onButtonClick={() => handleClose()}
                        extraClass={"w-full"}/>
                    <SystemPrimaryCustomButton
                        label={kSystemTexts.leave}
                        isDisabled={false}
                        isLoading={false}
                        isFullWidth={true}
                        onButtonClick={leave}
                        sizeStyle={kButtonStyles.mediumButtonStyle}/>
                </div>
            </div>
        </Modal>
    )
}